__turbopack_context__.v({
  "marker": "hHfE5a_marker",
  "tooltip": "hHfE5a_tooltip",
});
